export const transformPlotData = (data) => {
    const newData = {};
    for (const [key, value] of Object.entries(data)) {
        if (key && value) {
            // lowercase the key and remove any special symbol
            const optimizedKey = key?.toLowerCase()?.replace(/[^a-z0-9]/g, '');
            if (optimizedKey) {
                newData[optimizedKey] = value;
            }
        }
    }
    return newData;
}

export const safeParseJson = (maybeJson) => {
    if (!maybeJson) return {};
    if (typeof maybeJson === 'object') return maybeJson;
    if (typeof maybeJson === 'string') {
        try {
            return JSON.parse(maybeJson);
        } catch (_err) {
            return {};
        }
    }
    return {};
}

export const detectAxes = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) {
        return { xKey: undefined, yKeys: [] };
    }
    const sample = rows[0] || {};
    const keys = Object.keys(sample);

    const preferredXCandidates = ['date', 'time', 'month', 'year', 'period'];
    let xKey = keys.find(k => preferredXCandidates.includes(String(k).toLowerCase()));
    if (!xKey) {
        xKey = keys.find(k => typeof sample[k] !== 'number') || keys[0];
    }

    const yKeys = keys.filter(k => k !== xKey && typeof sample[k] === 'number');
    return { xKey, yKeys };
}

export const normalizePlotConfig = (dataToPlot, dataRows = [], fallbackTitle = 'Report', fallbackType = 'line') => {
    const rawPlotConfig = safeParseJson(dataToPlot);
    const optimizedConfig = transformPlotData(rawPlotConfig);

    const chartHeading = optimizedConfig?.title || fallbackTitle;
    const chartType = optimizedConfig?.plottype || fallbackType;

    let configuredYKeys = optimizedConfig?.yaxis;
    if (configuredYKeys && !Array.isArray(configuredYKeys)) {
        configuredYKeys = [configuredYKeys];
    }

    const { xKey: inferredXKey, yKeys: inferredYKeys } = detectAxes(dataRows);
    const finalXKey = optimizedConfig?.xaxis || inferredXKey;
    const finalYKeys = (configuredYKeys && configuredYKeys.length > 0) ? configuredYKeys : inferredYKeys;

    return {
        chartHeading,
        chartType,
        xAxisKey: finalXKey,
        yAxisKeys: finalYKeys,
        optimizedConfig,
    };
}

export const createBotMessage = (message) => {
    const botMessage = {
        query_id: message.query_id,
        sender: 'bot',
        content: message?.summary || message?.answer,
        copyContent: `summary - ${message?.summary_actions?.summary_text} actions - ${message?.summary_actions?.actions_text}`,
        actions: message?.actions,
        sqlQuery: message?.sql_query || '',
        firstMessage: 'no',

    };

    if (message?.df_data?.length >= 1 && message?.highchart_code?.length >= 1) {
        const chartObj = {
            graphTitle: message?.graph_head,
            graphType: message?.graph_type,
            graph: JSON.parse(message?.df_data),
            graphDataToPlot: JSON.parse(message?.highchart_code),
            viewType: "chart"
        };

        const requiredFields = ["title", "plottype", "xaxis", "yaxis"];
        const transformedPlotData = transformPlotData(chartObj?.graphDataToPlot || {});
        const hasRequiredFields = requiredFields.every(field => transformedPlotData.hasOwnProperty(field))

        if (hasRequiredFields) {
            Object.assign(botMessage, chartObj);
        } else {
            console.log("Not Enough data for chart", chartObj.graphDataToPlot)
        }
    }

    return botMessage;
};

export const getContextFromChats = (chats, config = { contextSize: 20, data: {} }) => {
    // Get the context size from the config
    const { contextSize, data } = config;
    // Read only bot messages that are not the first message
    const filterBotMessages = (chat) => chat.sender === 'bot' && chat?.firstMessage !== 'yes';
    // Get the context object for the chat
    const getContextObject = (chat) => ({
        user_id: data?.user_id,
        question: chat?.askedQuestion,
        summary: chat.content,
        actions: chat?.actions,
        automation: chat?.automation ?? {},
        timestamp: chat?.timestamp || new Date(),
        sql: chat?.sqlQuery ?? "",
        success: chat.actualBotResponse.status,
    })

    // Get the context from the chats
    const context = chats
        .filter(filterBotMessages)
        .slice(-contextSize)
        .map(getContextObject)

    return context;
}